import Logo from '../Welcome/Logo_w_Text_Large.png';

const Welcome: React.FC = () => {

    return (
        <div style={{ width: '100vw', height: '95vh', backgroundColor: '#191919' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',  color: 'white', fontSize: '32px', height: '100%', width: '100%' }}>
                <img src={Logo} width='500px' height='500px' alt='Doppeltone Logo' />
                <p>Create <b>New</b> choreography, or <b>Load</b> one from the menu above!</p>
            </div>
        </div>
    );
}

export default Welcome;